<template>
  <div>
    <template>
      <section class="h-screen font-sans bg-cover">
        <form v-on:submit.prevent class="container mx-auto h-full flex flex-1 justify-center items-center">
          <div class="max-w-sm w-96 m-4 p-10 bg-white rounded shadow-xl">

            <div class="content">
              <h2 class="mb-4 font-bold text-xl">{{ $t('auth.forgot-password') }}</h2>
              <input @keypress="cleanError($event.target)" v-model="email" required placeholder="Email" v-bind:class="{ 'mb-1 p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full': msgErrorMail, 'mb-6 p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full': !msgErrorMail }">
              <p class="text-red-500 pb-1">{{ msgErrorMail ? $t('auth.invalid-mail') : ''}}</p>
            </div>
            <footer>
              <common-button
                @click="forgot"
                type="primary"
                :submit="true"
                :is-loading="isLoading"
                :full-width="true"
                :disabled="isProcessing || !email">{{ $t('auth.ask-new-password') }}</common-button>
            </footer>

            <div class="mt-1">
              <router-link :to="{ name: 'signin' }" class="text-green-800 font-bold">Go to {{ $t('auth.signin') }}</router-link>
            </div>
          </div>

          <h1 class="font-logo text-4xl ml-10"><span class="text-gray-600">Rocket</span><span class="text-primary">fid</span></h1>
        </form>
      </section>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      isLoading: false,
      isProcessing: false,
      EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      msgErrorMail: false,
      message0: '',
      forgotPasswordPage: true,
      errorCode: ''
    }
  },
  methods: {
    cleanError () {
      this.isProcessing = false
      this.msgErrorMail = false
    },
    validateEmail () {
      if (this.EMAIL_REGEX.test(this.email)) {
        this.isProcessing = false
        this.msgErrorMail = false
      } else {
        this.isProcessing = true
        this.msgErrorMail = true
      }
    },
    async forgot () {
      this.validateEmail()
      if (!this.msgErrorMail) {
        if (!this.isProcessing && !this.isLoading) {
          this.isProcessing = true
          this.isLoading = true
          await new Promise(resolve => setTimeout(resolve, 1000))

          this.$store.dispatch('user/rememberPassword', this.email)
            .then(() => {
              this.$notify({title: 'Success', message: this.$root.$t('notifications.user.passwordSent'), type: 'success'})
            }).catch((response) => {
              if (response.code === '21' && this.forgotPasswordPage) {
                this.errorCode = 25
              } else {
                this.errorCode = response.code
              }
              this.$notify.error({
                title: this.$root.$t('api.' + this.errorCode + '.title'),
                message: this.$root.$t('api.' + this.errorCode + '.message')
              })
            }).then(() => {
              this.isProcessing = false
              this.isLoading = false
            })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Auth/ForgotPassword.vue